import React, { useState } from 'react'
import { Form, Button, Alert, InputGroup } from "react-bootstrap";
import { serGetCrsytal, serSetaAddCrsytal } from '../../axios';
import langList from '../../utils/languagelist.json'
import { useSelector } from 'react-redux';

export default function Crsytal() {
  const [inputValue,setInputValue]=useState('')
  const [inputNum,setInputNum]=useState(0)
  const [inputDis,setInputDis]=useState('')
  const [msgInfo,setMsgInfo]=useState('')
  const {lg}=useSelector((state)=>state.language)

  const handleQueryBtnClick=() => {
    if(msgInfo) return;
    if(!inputValue)return;
    const emailRegex = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/;
    if (!emailRegex.test(inputValue)) {
      setMsgInfo(`0${langList.public3[lg]}`);
      return;
    };
    serGetCrsytal({name:inputValue})
    .then(res =>{
      const code=res.code;
      if(code===40){
        setInputDis(res.data)
      }else{
        setMsgInfo(`0${langList.crsytal1[lg]}`);
      };
    })
    .catch(err =>{
      setMsgInfo('0'+err.message);
    });
  };
  const handleAddBtnClick=() => {
    if(!inputValue)return;
    if(inputNum*1===0)return;
    serSetaAddCrsytal({name:inputValue,value:inputNum})
    .then(res =>{
      const code=res.code;
      if(code===41){
        setMsgInfo(`1${langList.crsytal2[lg]}`);
      }else if(code===42){
        setMsgInfo(`0${langList.crsytal3[lg]}`);
      }else if(code===43){
        setMsgInfo(`0${langList.crsytal4[lg]}`);
      }else{
        setMsgInfo(`0${langList.crsytal5[lg]}`);
      };
    })
    .catch(err =>{
      setMsgInfo('0'+err.message);
    });
  };
  const handleImgPasteClick= async () => {
    try {
      const clipboardText = await navigator.clipboard.readText();
      setInputValue(clipboardText);
    } catch (error) {
      setMsgInfo(`0${langList.permission5[lg]}`);
    }
  };
  const handleImgCopyClick= async () => {
    try {
      await navigator.clipboard.writeText(inputValue);
    } catch (error) {
      setMsgInfo(`0${langList.permission6[lg]}`);
    }
  };
  const handleInputChang = (e) => {
    setInputValue(e.target.value)
    setInputDis('')
    setInputNum(0)
  }
  // 提示框
  const chip=(
    <Alert show={msgInfo===''?false:true} 
      variant={msgInfo.substring(0,1)==='0'?'danger':'success'} 
      className='py-1 text-center text-danger w-100'
    >
      {msgInfo.substring(1)}
    </Alert>
  )
  if(msgInfo){
    setTimeout(() => {
      setMsgInfo('');
    }, 5000);
  };


  return (
    <div className='my-4'>
      <InputGroup>
        <InputGroup.Text onClick={handleImgPasteClick} style={{cursor:'pointer'}}>
          <img src='./pic/clipboard-plus.svg' alt=''/>
        </InputGroup.Text>
        <Form.Control
          id='usercrsytal'
          type="text"
          placeholder={langList.permission7[lg]}
          value={inputValue}
          onChange={handleInputChang}
        />
        <InputGroup.Text onClick={handleImgCopyClick} style={{cursor:'pointer'}}>
          <img src='./pic/copy.svg' alt=''/>
        </InputGroup.Text>
      </InputGroup>
      <div className='d-flex justify-content-between mt-3'>
        <div className='d-flex justify-content-start'>
          <p className='my-1'>{langList.crsytal6[lg]}</p>
          <Form.Control id='numbercrsytaldis'
            type="text" disabled
            value={inputDis}
            style={{width:'100px'}}
          />
        </div>
        <Button variant="primary"
          onClick={handleQueryBtnClick}
        >{langList.crsytal7[lg]}</Button>
      </div>
      <div className='d-flex justify-content-between mt-3'>
        <div className='d-flex justify-content-start'>
          <p className='my-1'>{langList.crsytal8[lg]}</p>
          <Form.Control id='numbercrsytal'
            type="text" style={{width:'100px'}}
            value={inputNum} placeholder={langList.crsytal9[lg]}
            onChange={(e) => setInputNum(e.target.value)}
          />
        </div>
        <Button variant="primary"
          onClick={handleAddBtnClick}
        >{langList.crsytal10[lg]}</Button>
      </div>
      {msgInfo && chip}
    </div>
  );
}
